<div class="flex flex-justify-between"
     sizeClass="S: c1, !S: p1">
    <p>{{product?.data.name}}</p>
    <price [value]="product?.data.price"></price>
</div>
<p class="c1 m-t-1 m-t-2-s col-11">{{product?.data.description}}</p>
<div class="m-t m-t-3-s flex flex-middle"
     [style.padding-left]="client.isS ? '4px !important' : '2px !important'"
     [style.padding-top]="client.isS ? '0px !important' : '2px !important'">
    <checkbox [(ngModel)]="checked"
              [style.padding-left]="client.isS ? '26px !important' : '30px !important'"
              [name]="fieldName">
        <span class="c1 col-11 pos-relative"
              style="top: -1px">
            {{'Assemble Furniture' | translate }}
        </span>
    </checkbox>
    @if (status.busy) {
    <span class="p-l-2">
        <i class="icon-loading"></i>
    </span>
    }
</div>
